const toSafePathSegment = (value?: string | null) => {
  if (!value) {
    return "";
  }

  return encodeURIComponent(value.trim().replace(/\s+/g, "-"));
};

export default toSafePathSegment;
